<template>
  <div v-loading="loading" class="degree-sign-up-upload">
    <el-card>
      <div slot="header" class="card-header">
        <span class="title">上传资料</span>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="手机号：">
          <span class="form-text">{{ form.phone }}</span>
        </el-form-item>

        <el-form-item label="真实姓名：" prop="name">
          <div class="form-item-wrap">
            <el-input v-model="form.name" placeholder="请输入真实姓名" maxlength="32"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="身份证号：" prop="idCard">
          <div class="form-item-wrap">
            <el-input v-model="form.idCard" placeholder="请输入身份证号" maxlength="18"></el-input>
          </div>
        </el-form-item>

        <el-form-item ref="idCardPhoto" label="证件照片：" prop="idCardFrontPhoto">
          <div class="align-start">
            <div class="id-card-upload">
              <div class="id-card-item">
                <upload-image
                  v-model="form.idCardFrontPhoto"
                  :upload-img="$refs.idCardFrontPhoto"
                  :pic-type="'.jpg,.png,.jpeg'"
                ></upload-image>
                <div class="upload-label">正面</div>
              </div>
              <div class="id-card-item">
                <upload-image
                  v-model="form.idCardBackPhoto"
                  :upload-img="$refs.idCardBackPhoto"
                  :pic-type="'.jpg,.png,.jpeg'"
                ></upload-image>
                <div class="upload-label">背面</div>
              </div>
            </div>
            <span class="imagetips">大小5MB，支持jpg、png、jpeg</span>
          </div>
        </el-form-item>

        <el-form-item ref="registrationPhoto" label="登记照：" prop="registrationPhoto">
          <div class="align-start">
            <div class="register-photo-upload">
              <upload-image
                v-model="form.registrationPhoto"
                :upload-img="$refs.registrationPhoto"
                :width-size="295"
                :height-size="413"
                :pic-type="'.png,.jpg,.jpeg'"
              ></upload-image>
            </div>
            <div class="imagetips">1寸彩色白底免冠照片，大小5MB，支持png，最多可上传1张</div>
          </div>
        </el-form-item>

        <el-form-item label="当前学历：" prop="currentDegree">
          <el-select
            v-model="form.currentDegree"
            placeholder="请选择当前学历"
            @change="handleDegreeChange"
          >
            <el-option
              v-for="item in degreeOptions"
              :key="item.educationTagId"
              :label="item.tagName"
              :value="item.tagName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="form.currentDegree === '专升本'"
          label="学历认证报告："
          prop="authReport"
        >
          <div class="align-start">
            <div class="degreeUpload">
              <upload-file
                v-model="form.authReport"
                :file-type="'.pdf,.docx,.doc'"
                :limit="1"
              ></upload-file>
              <span class="imagetips">大小5MB，支持.pdf,.docx,.doc，最多可上传1个</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item ref="diplomaPhoto" label="毕业证照片：" prop="diplomaPhoto">
          <div class="align-start">
            <div class="diploma-phone">
              <upload-image
                v-model="form.diplomaPhoto"
                :upload-img="$refs.diplomaPhoto"
                :pic-type="'.png,.jpg,.jpeg'"
              ></upload-image>
              <span class="imagetips">大小5MB，支持png,jpg,jpeg，最多可上传1张</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="报名登记表：" prop="signForm">
          <div class="form-item-wrap align-start">
            <div class="signForm">
              <upload-file
                v-model="form.signForm"
                :file-type="'.docx,.doc,.xlsx,.xls'"
                :limit="1"
              ></upload-file>
              <span>大小5MB，支持.docx,.doc,.xlsx,.xls，最多可上传1个</span>
            </div>
            <div class="tip-text-block">
              <a class="download-link" @click="downloadTemplate">下载报名登记表模板</a>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="附件：" prop="attachments">
          <div class="align-start filesForm">
            <upload-file v-model="form.attachments" :limit="10"></upload-file>
            <span class="imagetips">每个文件限制10MB内,最多可上传10个</span>
          </div>
        </el-form-item>

        <el-form-item class="form-btns">
          <el-button type="primary" :loading="submitting" @click="handleSubmit">提交</el-button>
          <el-button @click="handleBack">返回报名资料</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import UploadFile from '@/components/UploadFile'
import { degreeEnrollDetail, degreeMaterialUpdate } from '@/api/degree'
import { isIDcard } from '@/utils/validate'
import to from 'await-to'
import { deGreeTypeTagFilter } from '@/api/center'

const checkIdCard = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入身份证号'))
  }
  if (!isIDcard(value)) {
    return callback(new Error('身份证格式不正确'))
  }
  callback()
}

const checkIdCardPhoto = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请上传身份证正面照片'))
  }
  callback()
}

const checkUpload = message => (rule, value, callback) => {
  if (!value || (Array.isArray(value) && !value.length)) {
    return callback(new Error(message))
  }
  callback()
}

export default {
  name: 'DegreeSignUpUpload',
  components: {
    UploadImage,
    UploadFile,
  },
  data() {
    return {
      degreeOptions: [],
      loading: false,
      submitting: false,
      form: {
        degreeEnrollId: '',
        phone: '',
        name: '',
        idCard: '',
        idCardFrontPhoto: '',
        idCardBackPhoto: '',
        registrationPhoto: '',
        currentDegree: '',
        diplomaPhoto: '',
        authReport: [],
        signForm: [],
        attachments: [],
        applyFormUrl: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { max: 32, message: '最多32个字', trigger: 'blur' },
        ],
        idCard: [{ required: true, validator: checkIdCard, trigger: 'blur' }],
        idCardFrontPhoto: [{ required: true, validator: checkIdCardPhoto, trigger: 'change' }],
        registrationPhoto: [
          { required: true, validator: checkUpload('请上传登记照'), trigger: 'change' },
        ],
        currentDegree: [{ required: true, message: '请选择当前学历', trigger: 'change' }],
        authReport: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.form.currentDegree !== '专升本') {
                return callback()
              }
              if (!value || (Array.isArray(value) && !value.length)) {
                return callback(new Error('请上传学历认证报告'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        diplomaPhoto: [
          { required: true, validator: checkUpload('请上传毕业证照片'), trigger: 'change' },
        ],
        signForm: [
          { required: true, validator: checkUpload('请上传报名登记表'), trigger: 'change' },
        ],
        // attachments: [{ required: true, validator: checkUpload('请上传附件'), trigger: 'change' }],
      },
    }
  },
  mounted() {
    this.getEducationTypeList()
    this.form.degreeEnrollId = this.$route.query.degreeEnrollId
    this.$nextTick(() => {
      if (this.form.degreeEnrollId) {
        this.getDetail()
      }
    })
  },
  methods: {
    async getEducationTypeList() {
      const [res, err] = await to(deGreeTypeTagFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.degreeOptions = res.data || []
    },
    handleDegreeChange() {
      this.form.authReport = []
      this.$refs.form && this.$refs.form.clearValidate('authReport')
    },
    async getDetail() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(degreeEnrollDetail({ degreeEnrollId: this.form.degreeEnrollId }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      const data = res.data || {}
      this.form = {
        ...this.form,
        phone: data.phone || '',
        name: data.name || '',
        idCard: data.idCard || '',
        idCardFrontPhoto: data.idCardFrontPhoto || '',
        idCardBackPhoto: data.idCardBackPhoto || '',
        registrationPhoto: data.registrationPhoto || '',
        currentDegree: data.currentDegree || '',
        diplomaPhoto: data.diplomaPhoto || '',
        authReport: data.authReport ? [{ docName: '学历认证报告', url: data.authReport }] : [],
        signForm: data.signForm ? [{ docName: '报名登记表', url: data.signForm }] : [],
        attachments: data.attachments || [],
        applyFormUrl: data.applyFormUrl || '',
      }
      console.log(this.form)
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (!this.form.idCardBackPhoto) {
          return this.$message.warning('请上传身份证背面照片')
        }
        if (this.form.attachments.length > 0) {
          this.form.attachments.forEach(element => {
            element.fileName = element.name || element.fileName
          })
        }
        const params = {
          degreeEnrollId: this.form.degreeEnrollId,
          name: this.form.name,
          idCard: this.form.idCard,
          idCardFrontPhoto: this.form.idCardFrontPhoto,
          idCardBackPhoto: this.form.idCardBackPhoto,
          registrationPhoto: this.form.registrationPhoto,
          currentDegree: this.form.currentDegree,
          diplomaPhoto: this.form.diplomaPhoto,
          authReport: this.form.authReport.length ? this.form.authReport[0].url : '',
          authReportName: this.form.authReport.length ? this.form.authReport[0].name : '',
          signForm: this.form.signForm.length ? this.form.signForm[0].url : '',
          signFormName: this.form.signForm.length ? this.form.signForm[0].name : '',
          attachments: this.form.attachments,
          authReportCheck: this.form.authReport.length ? true : false,
        }
        this.$confirm('您确认提交报名材料吗?', '确认提交', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const [, err] = await to(degreeMaterialUpdate(params))
          if (err) return this.$message.error(err.msg)
          this.$message.success('提交成功')
          this.handleBack()
        })
      })
    },
    handleBack() {
      this.$router.push({
        path: '/degree/degreeSignUp/detail',
        query: { degreeEnrollId: this.form.degreeEnrollId },
      })
    },
    downloadTemplate() {
      if (!this.form.applyFormUrl) {
        return this.$message.info('暂无模板文件')
      }
      const a = document.createElement('a')
      a.href = this.form.applyFormUrl
      a.download = '报名登记表模板'
      a.click()
    },
  },
}
</script>

<style lang="scss" scoped>
.degree-sign-up-upload {
  // padding: 20px;
  background: #fff;

  .card-header {
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
  }

  .form-text {
    font-size: 14px;
    color: #333;
  }
  .imagetips {
    color: #999999;
    line-height: 14px;
  }
  .form-item-wrap {
    display: flex;
    align-items: center;

    &.align-start {
      align-items: flex-start;
      span {
        color: #999999;
        line-height: 14px;
      }
    }

    .tip-text,
    .tip-text-block {
      // margin-left: 10px;
      margin-top: 70px;
      color: #ff4d4f;
      font-size: 14px;
      line-height: 1.6;
    }

    .tip-text-block {
      p {
        margin: 0 0 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .download-link {
      color: #ff7b33;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .id-card-upload {
    display: flex;

    .id-card-item {
      margin-right: 30px;

      ::v-deep .uploader {
        .el-upload {
          width: 160px;
          height: 100px;

          .el-icon-upload {
            margin-top: -20px;
            margin-left: -20px;
            font-size: 40px;
          }
        }
      }

      .upload-label {
        text-align: center;
        font-size: 14px;
        line-height: 18px;
        color: #999;
      }
    }
  }

  .register-photo-upload {
    ::v-deep .uploader {
      .el-upload {
        width: 120px;
        height: 160px;

        .el-icon-upload {
          margin-top: -24px;
          margin-left: -24px;
          font-size: 48px;
        }
      }
    }
  }
  .diploma-phone {
    ::v-deep .uploader {
      height: 100px;
      .el-upload {
        width: 160px;
        height: 100px;

        .el-icon-upload {
          margin-top: -24px;
          margin-left: -24px;
          font-size: 48px;
        }
      }
    }
  }
  .signForm {
    ::v-deep .uploader-file {
      .el-upload-dragger {
        width: 260px;
        height: 160px;
        .el-icon-upload {
          font-size: 54px;
          margin: 30px 0 0px;
        }
        .el-upload__text {
          font-size: 14px;
        }
      }
    }
  }
  .degreeUpload {
    ::v-deep .uploader-file {
      .el-upload-list__item {
        width: 600px;
      }
    }
  }
  .filesForm {
    ::v-deep .uploader-file {
      .el-upload-list__item {
        width: 600px;
      }
    }
  }
  .form-btns {
    margin-top: 40px;
    .el-button + .el-button {
      margin-left: 32px;
    }
  }
}
</style>
